module.exports = __webpack_public_path__ + "static/media/om_eyeshape_upturned_brown.5390267a.png";